import { NodeRendererProps } from "react-arborist";
import FeatherIcon from 'feather-icons-react';
import { FileDtoItemTypeEnum } from "generated/apiFiles";

export default function TreeNode({ node, style }: NodeRendererProps<any>) {
  // Gestisco manualmente il toggle cliccando sul div
  const handleClick = () => {
    console.log("Node clicked:", node);
    if (node.data.itemType === FileDtoItemTypeEnum.Folder) {
      console.log("Toggling folder:", node.data.name);
      node.toggle();
    }
  };

  const folderColor = "#f57c00"; // arancione
  const fileColor = "#03a9f4";   // celeste


  {console.log('node data: ', node.data)}
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        gap: 8,
        cursor: "pointer",
      // verde scuro cartella, grigio file
        userSelect: "none",
      }}
      onClick={handleClick}
    >
      <span>{node.data.itemType === "FOLDER"  ? (node.isOpen ? <FeatherIcon color={folderColor} icon="folder-plus" /> : <FeatherIcon color={folderColor} icon="folder" />) :  node.data.itemType === "FILE" ? <FeatherIcon color={fileColor} icon="file" /> : <FeatherIcon color={fileColor} icon="video" />}</span>
      <span>{node.data.name.length > 20
          ? `${node.data.name.slice(0, 20)}...`
          : node.data.name}
      </span>
    </div>
  );
}
